module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-de3985a922b4cbc1d518fda77394abfd.eot";